export default {
      id: "benefits-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#benefits",
      toString: function () {
        return this.url;
      }
    }